import { ErrorOutline } from '@mui/icons-material';
import { Box, Fade, Link, Typography } from '@mui/material';
import { FallbackProps } from 'react-error-boundary';
import { useTranslation } from 'react-i18next';

export type ErrorProps = FallbackProps & {
  ebName?: string;
  error: Error;
  resetErrorBoundary?: () => void;
};

const Error = ({ ebName, error, resetErrorBoundary }: ErrorProps) => {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        position: 'static',
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexGrow: 1,
      }}
      data-testid="Error"
    >
      <Fade in={true} timeout={1000}>
        <Box maxWidth={500} p={1} sx={{ wordBreak: 'break-word' }}>
          <Box display="flex" alignItems="center" justifyContent="flex-start">
            <ErrorOutline />
            <Typography variant="h5" component="h2">
              {t('Error.title')}
            </Typography>
          </Box>
          {error && (
            <>
              <Typography component="p" data-testid="Error.Message">
                {error?.message}
              </Typography>
            </>
          )}
          {resetErrorBoundary && (
            <Box mt={1}>
              {t('Error.refresh')}{' '}
              <Link
                component="button"
                variant="body1"
                color="primary"
                onClick={resetErrorBoundary}
                data-testid="Error.Reset"
                sx={{ verticalAlign: 'inherit' }}
              >
                {t('Error.reset')}
              </Link>
              .
            </Box>
          )}
          <Typography variant="caption" sx={{ color: 'text.secondary' }}>
            {ebName} boundary
          </Typography>
        </Box>
      </Fade>
    </Box>
  );
};

export default Error;
